import React from 'react';
import './settings.css';
import { useSelector } from "react-redux";
import Header from "../../components/Header/Header";
import SettingsHeader from "../../components/PagesHeaders/SettingsHeader/SettingsHeader";
import EstablishmentSettings from "../../components/EstablishmentSettings/EstablishmentSettings";
import SubscriptionTypes from "../../components/SubscriptionTypes/SubscriptionTypes";
import SubscriptionDurations from "../../components/SubscriptionDurations/SubscriptionDurations";
import SubscriptionConstraints from "../../components/SubscriptionConscraints/SubscriptionConstraints";
import SubscriptionTypeForm from "../../components/SubscriptionTypeForm/SubscriptionTypeForm";
import SubscriptionWorkoutsCount from "../../components/SubscriptionWorkoutsCount/SubscriptionWorkoutsCount";
import SubscriptionDurationForm from "../../components/SubscriptionDurationForm/SubscriptionDurationForm";
import SubscriptionWorkoutsForm from "../../components/SubscriptionWorkoutsForm/SubscriptionWorkoutsForm";
import SubscriptionConstraintForm from "../../components/SubscriptionConstraintForm/SubscriptionConstraintForm";
import PaymentMethodsForm from "../../components/PaymentMethodsForm/PaymentMethodsForm";
import PaymentMethods from "../../components/PaymentMethods/PaymentMethods";
import DiscountForm from "../../components/DiscountForm/DiscountForm";
import Discounts from "../../components/Discounts/Discounts";
import OtherSettings from "../../components/OtherSettings/OtherSettings";
import RemoveData from "../../components/RemoveData/RemoveData";

const Settings = () => {
    const settings_tab = useSelector(state => state.settings_tab);
    const typeOpenSettingsForm = useSelector(state => state.typeOpenSettingsForm);

    return (
        <>
            <Header component={ <SettingsHeader/>} />
            {
                typeOpenSettingsForm === 'types'
                ? <SubscriptionTypeForm/>
                : typeOpenSettingsForm === 'duration'
                ? <SubscriptionDurationForm/>
                : typeOpenSettingsForm === 'constraints'
                ? <SubscriptionConstraintForm/>
                : typeOpenSettingsForm === 'workouts'
                ? <SubscriptionWorkoutsForm/>
                : typeOpenSettingsForm === 'payment_methods'
                ? <PaymentMethodsForm/>
                : typeOpenSettingsForm === 'discount'
                ? <DiscountForm/>
                : false
            }
            <div className="page">
                {
                    settings_tab === 'establishment'
                    ? <EstablishmentSettings />
                    : settings_tab === 'subscription_types'
                    ? <SubscriptionTypes/>
                    : settings_tab === 'subscription_durations'
                    ? <SubscriptionDurations/>
                    : settings_tab === 'subscription_constraints'
                    ? <SubscriptionConstraints/>
                    : settings_tab === 'subscription_workouts_count'
                    ? <SubscriptionWorkoutsCount/>
                    : settings_tab === 'payment_methods'
                    ? <PaymentMethods/>
                    : settings_tab === 'discount'
                    ? <Discounts/>
                    : settings_tab === 'other'
                    ? <OtherSettings/>
                    : settings_tab === 'remove_data'
                    ? <RemoveData/>
                    : false
                }
            </div>
        </>
    );
};

export default Settings;